import { SignalWifi4Bar, SignalWifiOff } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import React from "react";

const DeviceStatusIcon = ({ status, sx = {} }) => {
  const theme = useTheme();

  if (status) {
    return (
      <SignalWifi4Bar
        sx={{
          color: theme.palette.success.main,
          ...sx,
        }}
      />
    );
  }

  return (
    <SignalWifiOff
      sx={{
        color: theme.palette.error.main,
        ...sx,
      }}
    />
  );
};

export default React.memo(DeviceStatusIcon);
